import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { AppService } from '../../app.service';
import { ApiService } from '../../share/services/api.service';
// import { ShareServiceClient } from "@azure/storage-file-share";
// import { GridDataResult } from '../share/models/griddataresult.model';
import FetrapiEnums from '../../share/enum/enums';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ValidationReportModalComponent } from '../../share/modals/validation-report/validation-report-modal.component';
import { EventService } from '../../share/services/event.service';
import { AuthService } from '../../share/services/auth.service';
import { SharedModule } from '../../share/shared.module';
import { DatasetModel } from '../../share/models/dataset-model.model';
import { ConfigService } from '../../share/services/config.service';
import { SessionService } from '../../share/services/session.service';

declare const L: any;

const shareName = 'fetrapishare';
// const serviceClient = new ShareServiceClient(environment['fetrapi'].ShareServiceClient);

@Component({
  selector: 'app-griddata',
  templateUrl: './griddata.component.html',
  styleUrls: ['./griddata.component.css'],
  imports: [SharedModule, ],
})
export class GriddataComponent implements OnInit {
  map!: L.Map;
  token: string = '';
  datasets: DatasetModel[] = [];
  isLoaded = false;
  isUploading = false;
  fileToUpload: File | undefined = undefined;
  isStagingChecked = true;
  isProductionChecked = false;
  isConsolidationChecked = false;

  consolidateDataset: DatasetModel | undefined = undefined;
  // loadedConsolidate = false;
  stagingDataset: DatasetModel | undefined = undefined;
  // loadedStaging = false;
  productionDataset: DatasetModel | undefined = undefined;
  // loadedProduction = false;
  chapter3ExportDataset: DatasetModel | undefined = undefined;
  adcrExportDataset: DatasetModel | undefined = undefined;
  stagingKLIMBufferDataset: DatasetModel | undefined = undefined;
  productionKLIMBufferDataset: DatasetModel | undefined = undefined;
  // loadedZoiExtracted = false;
  datasetExtractType: string = '';

  isFetrapiMember: boolean = false;
  isFetrapiAdmin: boolean = false;
  allowUpload: boolean = false;

  allmembersTileLayer!: L.TileLayer.WMSHeader; //any; // TODO // right type
  productionTileLayer!: L.TileLayer.WMSHeader; //any; // TODO // right type
  stagingTileLayer!: L.TileLayer.WMSHeader; //any; // TODO // right type
  allmembersLayer!: any; // TODO // right type
  stagingLayer!: any; // TODO // right type
  productionLayer!: any; // TODO // right type

  lcontrol!: L.Control;

  FetrapiEnums = FetrapiEnums;

  constructor(
    private eventService: EventService,
    public appService: AppService,
    private api: ApiService,
    private auth: AuthService,
    private modalService: NgbModal,
    private configService: ConfigService,
    private sessionService: SessionService
  ) {
    //Subscribe to the notification events
    this.eventService.getNotificationEvent().subscribe((notification) => {
      this.getmemberDatasets();
    });

    this.isFetrapiMember =
      this.sessionService.getMaingroupName() ==
      FetrapiEnums.MainGroups.FetrapiMember;
    this.isFetrapiAdmin =
      this.sessionService.getMaingroupName() ==
      FetrapiEnums.MainGroups.FetrapiAdmin;
  }

  ngOnInit(): void {
    //Initialize checkboxes based on role.
    if (this.isFetrapiMember) {
      this.isStagingChecked = true;
      this.isProductionChecked = false;
      this.isConsolidationChecked = false;
    } else {
      this.isStagingChecked = false;
      this.isProductionChecked = false;
      this.isConsolidationChecked = this.isFetrapiAdmin;
    }

    this.getmemberDatasets();
  }

  getmemberDatasets() {
    let memberId = undefined;
    if (!this.isFetrapiMember) {
      memberId = this.sessionService.getMaingroupGId();
    }

    if (this.isFetrapiMember) {
      let datasetTypes = '';
      datasetTypes += '"' + FetrapiEnums.DatasetType.Grid + '",';
      datasetTypes += '"' + FetrapiEnums.DatasetType.KLIMCICCBuffer + '",';
      datasetTypes += '"' + FetrapiEnums.DatasetType.ADCRExport + '",';
      datasetTypes += '"' + FetrapiEnums.DatasetType.Chapter3Export + '",';
      datasetTypes += '"' + FetrapiEnums.DatasetType.IntegratedGridData + '"';
      let datasetStatuscodes =
        '"' + FetrapiEnums.DatasetStatusCode.Active + '",';
      datasetStatuscodes +=
        '"' + FetrapiEnums.DatasetStatusCode.ValidationFailed + '",';
      datasetStatuscodes +=
        '"' + FetrapiEnums.DatasetStatusCode.ValidationSucceeded + '",';
      datasetStatuscodes +=
        '"' + FetrapiEnums.DatasetStatusCode.MemberApproved + '",';
      datasetStatuscodes +=
        '"' + FetrapiEnums.DatasetStatusCode.MemberRejected + '",';
      datasetStatuscodes +=
        '"' + FetrapiEnums.DatasetStatusCode.ConfirmationRequired + '"';

      this.api
        .getDataSets(datasetTypes, datasetStatuscodes, memberId)
        .subscribe((data: any) => {
          this.datasets = data;
          console.log(this.datasets);
          this.isLoaded = true;
          this.getStagingDataset();
          this.getProductionDataset();
          this.getStagingKLIMBufferDataset();
          this.getProductionKLIMBufferDataset();
          this.getConsolidateDatasets();
          //Reload stagingLayer map
          if (this.isStagingChecked) {
            this.map.removeLayer(this.stagingLayer);
            this.map.addLayer(this.stagingLayer);
            this.SetZIndex();
          }
          //Reload productionLayer map
          if (this.isProductionChecked) {
            this.map.removeLayer(this.productionLayer);
            this.map.addLayer(this.productionLayer);
            this.SetZIndex();
          }
          //Check if there is validation report
          if (this.stagingDataset) {
            this.hasValidationReport(this.stagingDataset, (s: boolean) =>
              this.endLoading(s)
            );
          }
        });
    } else {
      let datasetTypes = '';
      datasetTypes += '"' + FetrapiEnums.DatasetType.Grid + '",';
      datasetTypes += '"' + FetrapiEnums.DatasetType.KLIMCICCBuffer + '",';
      datasetTypes += '"' + FetrapiEnums.DatasetType.ADCRExport + '",';
      datasetTypes += '"' + FetrapiEnums.DatasetType.Chapter3Export + '",';
      datasetTypes += '"' + FetrapiEnums.DatasetType.IntegratedGridData + '"';
      let datasetStatuscodes =
        '"' + FetrapiEnums.DatasetStatusCode.Active + '",';
      datasetStatuscodes +=
        '"' + FetrapiEnums.DatasetStatusCode.ValidationFailed + '",';
      datasetStatuscodes +=
        '"' + FetrapiEnums.DatasetStatusCode.ValidationSucceeded + '",';
      datasetStatuscodes +=
        '"' + FetrapiEnums.DatasetStatusCode.MemberApproved + '"';
      this.api
        .getDataSets(datasetTypes, datasetStatuscodes, memberId)
        .subscribe((data: any) => {
          this.datasets = data;
          console.log(this.datasets);
          this.isLoaded = true;
          this.getConsolidateDatasets();
          // this.loadedConsolidate = true;
        });
    }

    // Reload consolidate map
    if (this.isConsolidationChecked && this.map) {
      this.map.removeLayer(this.allmembersLayer);
      this.map.addLayer(this.allmembersLayer);
      this.SetZIndex();
    }
  }

  getDataset(filteredDatasets: DatasetModel[]): DatasetModel | undefined {
    let datasets = filteredDatasets.sort((a, b) => {
      return a.dateTimeCreated < b.dateTimeCreated ? 1 : -1;
    });

    if (datasets.length == 0) {
      return undefined;
    }

    if (datasets.length > 1) {
      console.log(
        'Detected more than one ' +
          datasets[0].statusCode +
          ' ' +
          datasets[0].datasetType +
          ' datasets'
      );
      console.log(datasets);
    }

    return datasets[0];
  }

  getStagingKLIMBufferDataset() {
    this.stagingKLIMBufferDataset = this.getDataset(
      this.datasets.filter(
        (x) =>
          x.statusCode == FetrapiEnums.DatasetStatusCode.MemberApproved &&
          x.datasetType == FetrapiEnums.DatasetType.KLIMCICCBuffer
      )
    );
  }

  getProductionKLIMBufferDataset() {
    this.productionKLIMBufferDataset = this.getDataset(
      this.datasets.filter(
        (x) =>
          x.statusCode == FetrapiEnums.DatasetStatusCode.Active &&
          x.datasetType == FetrapiEnums.DatasetType.KLIMCICCBuffer
      )
    );
  }

  getStagingDataset() {
    this.stagingDataset = this.getDataset(
      this.datasets.filter(
        (x) =>
          x.statusCode != FetrapiEnums.DatasetStatusCode.Active &&
          x.statusCode != FetrapiEnums.DatasetStatusCode.ConfirmationRequired &&
          x.datasetType == FetrapiEnums.DatasetType.Grid
      )
    );

    if (this.stagingDataset == undefined) {
      this.allowUpload = true;
    } else {
      switch (this.stagingDataset.statusCode) {
        case FetrapiEnums.DatasetStatusCode.ValidationSucceeded:
          this.allowUpload = false;
          break;
        case FetrapiEnums.DatasetStatusCode.ValidationFailed:
        case FetrapiEnums.DatasetStatusCode.MemberApproved:
        case FetrapiEnums.DatasetStatusCode.MemberRejected:
          this.allowUpload = true;
          break;
        default:
          this.allowUpload = true;
          break;
      }
    }
  }

  getProductionDataset() {
    this.productionDataset = this.getDataset(
      this.datasets.filter(
        (x) =>
          (
            x.statusCode == FetrapiEnums.DatasetStatusCode.Active ||
            x.statusCode == FetrapiEnums.DatasetStatusCode.ConfirmationRequired
          ) &&
          x.datasetType == FetrapiEnums.DatasetType.Grid
      )
    );
  }

  getConsolidateDatasets() {
    this.consolidateDataset = this.getDataset(
      this.datasets.filter(
        (x) =>
          x.statusCode == FetrapiEnums.DatasetStatusCode.Active &&
          x.datasetType == FetrapiEnums.DatasetType.IntegratedGridData
      )
    );
    this.adcrExportDataset = this.getDataset(
      this.datasets.filter(
        (x) =>
          x.statusCode == FetrapiEnums.DatasetStatusCode.Active &&
          x.datasetType == FetrapiEnums.DatasetType.ADCRExport
      )
    );
    this.chapter3ExportDataset = this.getDataset(
      this.datasets.filter(
        (x) =>
          x.statusCode == FetrapiEnums.DatasetStatusCode.Active &&
          x.datasetType == FetrapiEnums.DatasetType.Chapter3Export
      )
    );
  }

  endLoading(endLoading: boolean) {
    this.isLoaded = endLoading;
  }

  hasValidationReport(dataset: DatasetModel, callback: any) {
    if (dataset == null) {
      if (callback) {
        callback(true);
      }

      return;
    }

    this.api.hasValidationReport(dataset.datasetId).subscribe({
      next: (data: any) => {
        dataset.hasValidationReport = data;

        if (callback) {
          callback(true);
        }
      },
      error: (error: any) => {
        if (error.status != 404) {
          this.api.errorhandler(error);
        }
        if (callback) {
          callback(true);
        }
      }
    })
  }

  downloadValidationReport(datasetId: string) {
    this.api.getValidationReport(datasetId).subscribe((data: any) => {
      const modal = this.modalService.open(ValidationReportModalComponent);
      modal.componentInstance.showValidationReport(data);
    })
  }

  async ngAfterViewInit() {
    const jwtToken = await localStorage.getItem('jwttoken');
    if (jwtToken !== null) {
      this.token = jwtToken;
    }

    console.log('L.Proj: ', L.Proj);
    const l72_crs = new L.Proj.CRS(
      'EPSG:31370',
      '+proj=lcc +lat_1=51.16666723333333 +lat_2=49.8333339 +lat_0=90 +lon_0=4.367486666666666 +x_0=150000.013 +y_0=5400088.438 +ellps=intl +towgs84=-106.869,52.2978,-103.724,0.3366,-0.457,1.8422,-1.2747 +units=m +no_defs',
      {
        resolutions: [1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5],
        origin: [14722.202449434262, 20841.15747877769],
      }
    );
    var GRBLayer = L.tileLayer.wms(
      this.configService.getEnv('geoservicesFL'),
      {
      zIndex: 0,
      layers: 'GRB_BSK',
      transparent: true,
      format: 'image/png',
      opacity: 0.4,
    });
    var URBISLayer = L.tileLayer.wms(
      this.configService.getEnv('geoservicesBR'),
      {
        zIndex: 1,
        layers: 'urbisFRGray',
        transparent: true,
        format: 'image/png',
        opacity: 0.4,
      }
    );
    var PICCLayer = L.tileLayer.wms(
      this.configService.getEnv('geoservicesWA'),
      {
        zIndex: 2,
        layers:
          '1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29',
        transparent: true,
        format: 'image/png',
        opacity: 0.4,
      }
    );
    this.allmembersTileLayer = L.TileLayer.wmsHeader(
      this.configService.getEnv('fetrapiApi') + 'GeoProxy',
      {
        layers: 'FetrapiBaseData:vw_fet_prod_all',
        zIndex: 11,
        transparent: true,
        format: 'image/png',
        opacity: 0.5,
      },
      [{ header: 'Authorization', value: 'Bearer ' + this.token }],
      null,
      null
    );
    this.productionTileLayer = L.TileLayer.wmsHeader(
      this.configService.getEnv('fetrapiApi') + 'GeoProxy?',
      {
        layers: 'FetrapiBaseData:vw_fet_prod_f',
        zIndex: 21,
        transparent: true,
        format: 'image/png',
      },
      [{ header: 'Authorization', value: 'Bearer ' + this.token }],
      null,
      null
    );
    this.stagingTileLayer = L.TileLayer.wmsHeader(
      this.configService.getEnv('fetrapiApi') + 'GeoProxy?',
      {
        layers: 'FetrapiBaseData:vw_fet_stag_f',
        zIndex: 31,
        transparent: true,
        format: 'image/png',
      },
      [{ header: 'Authorization', value: 'Bearer ' + this.token }],
      null,
      null
    );
    var backdrop = L.layerGroup([URBISLayer, PICCLayer, GRBLayer]);
    this.stagingLayer = L.layerGroup([this.stagingTileLayer]);
    this.productionLayer = L.layerGroup([this.productionTileLayer]);
    this.allmembersLayer = L.layerGroup([this.allmembersTileLayer]);
    var overlayMaps;
    if (this.isFetrapiMember) {
      this.map = new L.Map('map', {
        crs: l72_crs,
        center: [50.8, 4.6],
        minZoom: 1,
        maxZoom: 11,
        zoom: 1,
        worldCopyJump: false,
        layers: [backdrop, this.stagingLayer],
      });
      overlayMaps = {
        URBIS: URBISLayer,
        PICC: PICCLayer,
        GRB: GRBLayer,
      };
    } else {
      this.map = new L.Map('map', {
        crs: l72_crs,
        center: [50.8, 4.6],
        minZoom: 1,
        maxZoom: 11,
        zoom: 1,
        worldCopyJump: false,
        layers: [backdrop],
      });
      overlayMaps = {
        URBIS: URBISLayer,
        PICC: PICCLayer,
        GRB: GRBLayer,
      };
    }
    L.control
      .scale({ imperial: false, metric: true, position: 'bottomleft' })
      .addTo(this.map);
    this.lcontrol = L.control.layers(undefined, overlayMaps).addTo(this.map);
    if (this.isFetrapiAdmin) {
      this.map.addLayer(this.allmembersLayer);
      this.SetZIndex();
    }
  }

  downloadDataset(datasetId: string) {
    this.api.downloadDataset(datasetId).subscribe({
      next: (data: any) => {
        const element = document.createElement('a');
        element.href = data;
        document.body.appendChild(element);
        element.click();
      },
      error: (error: any) => {
        if (error.status == 404) {
          this.appService.showModalError(error.error.message);
        } else {
          this.api.errorhandler(error);
        }
      }
    })
  }

  changeDatasetStatus(datasetId: string, statusCode: FetrapiEnums.DatasetStatusCode) {
    this.api.updateDatasetStatus(datasetId, statusCode).subscribe({
      next: (data: any) => {
        this.getmemberDatasets();
      },
      error: (error: any) => {
        if (error.status == 404 || error.status == 400) {
          this.appService.showModalError(error?.error?.message);
        } else {
          this.api.errorhandler(error);
        }
      }
    })
  }

  approveDataset(datasetId: string) {
    this.changeDatasetStatus(
      datasetId,
      FetrapiEnums.DatasetStatusCode.MemberApproved
    );
  }

  rejectDataset(datasetId: string) {
    this.changeDatasetStatus(
      datasetId,
      FetrapiEnums.DatasetStatusCode.MemberRejected
    );
  }

  confirmDataset(datasetId: string) {
    this.changeDatasetStatus(
      datasetId,
      FetrapiEnums.DatasetStatusCode.MemberConfirmed
    );
  }

  handleFileInput(event: Event) {
    const files: FileList | null = (event.target as HTMLInputElement).files;
    if (files !== null && files.item(0) !== null) {
      this.fileToUpload = files.item(0) as File;
    }
    console.log(this.fileToUpload);
    this.uploadDataset();
  }

  uploadDataset() {
    this.isUploading = true;
    var memberid = this.sessionService.getMaingroupGId();
    var memberidmin = memberid.replace(/-/g, '');
    console.log('memberid: ' + memberidmin);
    if (this.fileToUpload != null && memberidmin != null) {
      this.api.GridData(this.fileToUpload).subscribe({
        next: (data: any) => {
          this.getmemberDatasets();
          this.isUploading = false;
        },
        error: (error: any) => {
            this.isUploading = false;
            if (error.status == 400) {
              this.appService.showModalError(error.error.message);
              this.getmemberDatasets();
          } else {
            this.api.errorhandler(error);
          }
        }
      });
    }

    this.fileToUpload = undefined;
  }

  ToggleStaging(event: any) {
    console.log(
      'Switching Staging Datasets from ' +
        this.isStagingChecked +
        ' to ' +
        !this.isStagingChecked
    );
    this.isStagingChecked = !this.isStagingChecked;
    if (this.isStagingChecked == true) {
      this.map.addLayer(this.stagingLayer);
      this.lcontrol = L.control
        .layers(undefined, this.stagingLayer)
        .addTo(this.map);
    }
    if (this.isStagingChecked == false) {
      this.map.removeLayer(this.stagingLayer);
    }
  }

  ToggleProduction(event: any) {
    console.log(
      'Switching Production Datasets from ' +
        this.isProductionChecked +
        ' to ' +
        !this.isProductionChecked
    );
    this.isProductionChecked = !this.isProductionChecked;
    if (this.isProductionChecked == true) {
      this.map.addLayer(this.productionLayer);
      this.lcontrol = L.control.layers(undefined, this.productionLayer).addTo(this.map);
    }
    if (this.isProductionChecked == false) {
      this.map.removeLayer(this.productionLayer);
    }
  }

  ToggleConsolidation() {
    console.log(
      'Switching Consolidation Datasets from ' +
        this.isConsolidationChecked +
        ' to ' +
        !this.isConsolidationChecked
    );
    this.isConsolidationChecked = !this.isConsolidationChecked;
    if (this.isConsolidationChecked == true) {
      this.map.addLayer(this.allmembersLayer);

      this.SetZIndex();
      //this.lcontrol = L.control.layers(null, this.allmembersLayer).addTo(this.map);
    }
    if (this.isConsolidationChecked == false) {
      this.map.removeLayer(this.allmembersLayer);
    }
  }

  SetZIndex() {
    if (this.isConsolidationChecked) {
      this.allmembersTileLayer.bringToFront();
    }
    if (this.isProductionChecked) {
      this.productionTileLayer.bringToFront();
    }
    if (this.isConsolidationChecked) {
      this.stagingTileLayer.bringToFront();
    }
  }
}
